/* import __COLOCATED_TEMPLATE__ from './upgrade-prompt-buttons.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { task } from 'ember-concurrency';
import clsx from 'clsx';

const CLASS_NAME = 'SH-c-upgrade-prompt-buttons';
const CLASS_NAME_THEME_WHITE = `${CLASS_NAME}--theme-white`;

class UpgradePromptButtons extends Component {
  @service('commands/company-commands') companyCommandService;
  @service('error-tracker') errorTracker;

  get classNames() {
    return clsx(
      this.args.class,
      CLASS_NAME,
      this.args.theme === 'white' && CLASS_NAME_THEME_WHITE,
    );
  }

  get baseClassName() {
    return CLASS_NAME;
  }

  get learnMoreHref() {
    return this.args.learnMoreLink || '/upgrade';
  }

  @task
  *contactTask() {
    try {
      yield this.companyCommandService.requestUpgrade(1, this.args.upgradeType);
    } catch {
      this.errorTracker.error(e, this, 'Failed to send upgrade request email');
    }
  }

  @action
  viewLink(url) {
    window.open(url, '_blank');
  }
}

export default UpgradePromptButtons;
